























import { Component, Vue } from 'vue-property-decorator';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import UserEvolutionChart from '@contacts/components/charts/user-evolution-chart.vue';
import { v4 as uuidv4 } from 'uuid';

import { DisplayOptions } from '@shared/interfaces/chart-interfaces';

@Component({
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-user-evolution-chart': UserEvolutionChart,
  },
})
export default class UserEvolutionPage extends Vue {
  // Props

  // DATA
  // LIFECYCLE
  // created(){}
  // mounted() {}
  // updated(){}
  // destroyed(){}
  // COMPUTED

  displayOptions: DisplayOptions = {
    showChartBar: true,
    showChartLine: true,
    showChartArea: false,
    showChartPie: false,
  };

  get actionsPortalTarget() {
    return `user-evolution-actions-${uuidv4()}`;
  }
  get navigationPortalTarget() {
    return `user-evolution-navigation-${uuidv4()}`;
  }

  // METHODS

  // WATCHERS
}
